/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

/** React library files */
import React from 'react';
import { connect } from 'react-redux';
import { isAuthorized } from 'shared/settings/auth';

/** Bootstrap */
import { Button } from 'react-bootstrap';

/** Style import */
import './Payment.scss';


/**

@Author Lakshmi V

@param

@return payment html

**/

// const PayPalButton = paypal.Button.driver('react', { React, ReactDOM });

class PaymentAutoDebit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            paymentAutoDebitAmount: this.props.location.state.autoDebitAmount
        }
    }

    back = () => {
        this.props.history.push('/my-account/invoice');
    }

    render() {
        return(
            <div className="payment-page">
                {
                    isAuthorized() ? <div className="back-button">
                        <Button variant="secondary" onClick={this.back}>Go Back</Button>
                    </div> : null
                }
                <div className="payment-container h-100 flex-fill d-flex flex-column align-items-center justify-content-center">
                    <div className="payment-success">
                        <i className="fas fa-check fa-3x"></i>
                        <span className="fa-3x">
                            Payment processing Success
                        </span>
                        <div className="loader d-flex align-items-center justify-content-center text-center">
                            <h3>Amount Paid: ${this.state.paymentAutoDebitAmount}</h3>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(state => state)(PaymentAutoDebit);